var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCbLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0626 56.6666C30.8369 56.6666 23.3646 49.2083 23.3646 40C23.3646 30.7916 30.8369 23.3333 40.0626 23.3333C48.3281 23.3333 55.1882 29.3472 56.5101 37.2222H73.3333C71.914 20.1111 57.5676 6.66663 40.0626 6.66663C21.6252 6.66663 6.66663 21.5972 6.66663 40C6.66663 58.4027 21.6252 73.3333 40.0626 73.3333C57.5676 73.3333 71.914 59.8888 73.3333 42.7777H56.5101C55.1882 50.6527 48.3281 56.6666 40.0626 56.6666Z",
    fill: "var(--background)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbLogo);
export default __webpack_public_path__ + "static/media/cbLogo.26a307adbc2a3819378cb1a4f91aa402.svg";
export { ForwardRef as ReactComponent };